// A prospect or a lost company gets no mission (the api refuses it with
// COMPANY_NOT_CLIENT); no stage means a client, as for the api.
export const isMissionCompany = (stage) => !stage || stage === 'client';
